import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions";
import * as API from "../api";
import Helper from "../../helpers/helpers";


export function* loadStateDistrictList() {

  yield takeEvery(actionTypes.LOAD_STATE_DISTRICT_LIST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("STATEDISTRICTLIST");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.loadStateDistrictList( action.state, action.district, action.data );
      if(response)
      {
        if (response.data.success) {
          yield put(actions.loadStateDistrictListSuccess(response.data.data));
        } else {
          yield put(actions.msgError(response.data.message));
        }
      }

      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
    }
  });
}


export function* loadLanguages() {

  yield takeEvery(actionTypes.LOAD_LANGUAGUES, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("LANGUAGELIST");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.loadLanguages(action.data);
      if(response)
      {
        if (response.data.success) {
          yield put(actions.loadLanguagesSuccess(response.data.data));
        } else {
          yield put(actions.msgError(response.data.message));
        }
      }

      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
    }
  });
}


export function* loadExpressRecyclingList() {
  
  yield takeEvery(actionTypes.LOAD_EXPRESS_RECYCLING_LIST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("EXPRESSRECYCLINGLIST");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.loadExpressRecyclingList(action.data);
      if(response)
      {
        if (response.data.success && response.data.data) {
    
          yield put(actions.loadExpressRecyclingListSuccess(response.data.data));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.loadExpressRecyclingListFail());
        }
      }

      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.loadExpressRecyclingListFail());
    }
  });
}

export function* loadRecyclingList() {
  
  yield takeEvery(actionTypes.LOAD_RECYCLING_LIST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("RECYCLINGLIST");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.loadRecyclingList(action.data);
      if(response)
      {
        if (response.data.success && response.data.data) {
    
          yield put(actions.loadRecyclingListSuccess(response.data.data));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.loadRecyclingListFail());
        }
      }

      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.loadRecyclingListFail());
    }
  });
}

export function* loadRecyclingCategory() {
  
  yield takeEvery(actionTypes.LOAD_RECYCLING_CATEGORY, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("RECYCLINGCATEGORY");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.loadRecyclingCategory(action.data);
      if(response)
      {
        if (response.data.success && response.data.data) {
    
          yield put(actions.loadRecyclingCategorySuccess(response.data.data));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.loadRecyclingCategoryFail());
        }
      }

      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.loadRecyclingCategoryFail());
    }
  });
}

export function* loadRecyclingExtraFee() {
  
  yield takeEvery(actionTypes.LOAD_RECYCLING_EXTRA_FEE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("RECYCLINGEXTRAFEE");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.loadRecyclingExtraFee(action.data);
      if(response)
      {
        if (response.data.success && response.data.data) {
    
          yield put(actions.loadRecyclingExtraFeeSuccess(response.data.data));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.loadRecyclingExtraFeeFail());
        }
      }

      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.loadRecyclingExtraFeeFail());
    }
  });
}

export function* loadRecyclingDumpster() {
  
  yield takeEvery(actionTypes.LOAD_RECYCLING_DMPSTER, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("RECYCLINGDMPSTER");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.loadRecyclingDumpster(action.data);
      if(response)
      {
        if (response.data.success && response.data.data) {
    
          yield put(actions.loadRecyclingDumpsterSuccess(response.data.data));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.loadRecyclingDumpsterFail());
        }
      }

      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.loadRecyclingDumpsterFail());
    }
  });
}

export function* loadDumpsterService() {
  
  yield takeEvery(actionTypes.LOAD_DMPSTER_SERVICE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DMPSTERSERVICE");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.loadDumpsterService(action.data);
      if(response)
      {
        if (response.data.success && response.data.data) {
    
          yield put(actions.loadDumpsterServiceSuccess(response.data.data));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.loadDumpsterServiceFail());
        }
      }

      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.loadDumpsterServiceFail());
    }
  });
}

export function* loadImpactCarbon() {
  
  yield takeEvery(actionTypes.LOAD_IMPACT_CARBON, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("LOADIMPACTCARBON");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.loadImpactCarbon(action.data);
      if(response)
      {
        if (response.data.success && response.data.data) {
    
          yield put(actions.loadImpactCarbonSuccess(response.data.data));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.loadImpactCarbonFail());
        }
      }

      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.loadImpactCarbonFail());
    }
  });
}

export function* getImpactCarbonCert() {
  
  yield takeEvery(actionTypes.GET_IMPACT_CARBON_CERT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GETIMPACTCARBONCERT");
    action.data.track_no = track_no

    yield put(actions.setLoading());

    try {
      const response = yield API.getImpactCarbonCert(action.data);
      if(response)
      {
        if (response.data.success && response.data.data) {
    
          yield put(actions.getImpactCarbonCertSuccess(response.data.data));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.getImpactCarbonCertFail());
        }
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.getImpactCarbonCertFail());
    }
  });
}

export function* getGeneralSetting() {
  
  yield takeEvery(actionTypes.GET_GENERAL_SETTING, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GETGENERALSETTING");
    action.data.track_no = track_no

    yield put(actions.setLoading());

    try {
      const response = yield API.getGeneralSetting(action.data);
      if(response)
      {
        if (response.data.success && response.data.data) {
    
          yield put(actions.getGeneralSettingSuccess(response.data.data));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.getGeneralSettingFail());
        }
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.getGeneralSettingFail());
    }
  });
}

export function* loadCharities() {
  
  yield takeEvery(actionTypes.LOAD_CHARITIES, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("LOADCHARITIES");
    action.data.track_no = track_no

    yield put(actions.setLoading());

    try {
      const response = yield API.loadCharities(action.data);
      if(response)
      {
        if (response.data.success && response.data.data) {
    
          yield put(actions.loadCharitiesSuccess(response.data.data));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.loadCharitiesFail());
        }
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadCharitiesFail());
    }
  });
}

export function* loadVendingCategory() {
  
  yield takeEvery(actionTypes.LOAD_VENDING_CATEGORY, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("VENDINGCATEGORY");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.loadVendingCategory(action.data);
      if(response)
      {
        if (response.data.success && response.data.data) {
    
          yield put(actions.loadVendingCategorySuccess(response.data.data));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.loadVendingCategoryFail());
        }
      }

      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.loadVendingCategoryFail());
    }
  });
}

export function* driverList() {
  
  yield takeEvery(actionTypes.LOAD_DRIVER_LIST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DRIVERLIST");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.driverList(action.data);
      if(response)
      {
        if (response.data.success && response.data.data) {
    
          yield put(actions.driverListSuccess(response.data.data));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.driverListFail());
        }
      }

      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.driverListFail());
    }
  });
}

export function* driverDRVMDumpsterList() {
  
  yield takeEvery(actionTypes.LOAD_DRIVER_DUMPSTER, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DRIVERDUMPSTER");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.driverDRVMDumpsterList(action.id, action.data);
      if(response)
      {
        if (response.data.success && response.data.data) {
    
          yield put(actions.driverDRVMDumpsterListSuccess(response.data.data));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.driverDRVMDumpsterListFail());
        }
      }

      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.driverDRVMDumpsterListFail());
    }
  });
}

export function* landfillPointList() {
  
  yield takeEvery(actionTypes.LOAD_LANDFILL_POINT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("LANDFILLPOINT");
    action.data.track_no = track_no

    // yield put(actions.enableLoading());

    try {
      const response = yield API.landfillPointList(action.data);
      if(response)
      {
        if (response.data.success && response.data.data) {
    
          yield put(actions.landfillPointListSuccess(response.data.data));
        } else {
          yield put(actions.msgError(response.data.message));
          yield put(actions.landfillPointListFail());
        }
      }

      // yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      // yield put(actions.disableLoading());
      yield put(actions.landfillPointListFail());
    }
  });
}


export default function* generalSaga() {
  
  yield all([fork(loadStateDistrictList)]);
  yield all([fork(loadLanguages)]);
  yield all([fork(loadRecyclingList)]);
  yield all([fork(loadExpressRecyclingList)]);
  yield all([fork(loadRecyclingCategory)]);
  yield all([fork(loadRecyclingExtraFee)]);
  yield all([fork(loadRecyclingDumpster)]);
  yield all([fork(loadDumpsterService)]);
  yield all([fork(loadImpactCarbon)]);
  yield all([fork(getImpactCarbonCert)]);
  yield all([fork(getGeneralSetting)]);
  yield all([fork(loadCharities)]);
  yield all([fork(loadVendingCategory)]);
  yield all([fork(driverList)]);
  yield all([fork(driverDRVMDumpsterList)]);
  yield all([fork(landfillPointList)]);
}
